'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../../../node_modules/tslib/tslib.es6.js');
var React = require('react');
var index = require('../../../node_modules/classnames/index.js');
var index_es = require('../../../node_modules/pure-react-carousel/dist/index.es.js');
var useMediaQuery = require('../../utils/hooks/useMediaQuery.js');
var breakpoint = require('../../utils/breakpoint.js');
require('./Carousel.scss.js');
require('../../../node_modules/pure-react-carousel/dist/react-carousel.es.css.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var Carousel = function (props) {
    var _a = React.useState(4), visibleSlides = _a[0], setVisibleSlides = _a[1];
    var isDesktop = useMediaQuery.useMediaQuery(breakpoint.BREAK_POINTS.desktop);
    var isTablet = useMediaQuery.useMediaQuery(breakpoint.BREAK_POINTS.tablet);
    // when user resizes the window it's equivalent effect on visible slides
    React.useEffect(function () {
        if (isDesktop) {
            setVisibleSlides(props.defaultVisibleSlide);
        }
        else if (isTablet) {
            setVisibleSlides(2);
        }
        else {
            setVisibleSlides(0.8);
        }
    }, [isTablet, isDesktop]);
    var classSliderCenterMode = props.centerMode ? 'center-mode' : '';
    React.useEffect(function () {
        if (props.defaultVisibleSlide) {
            setVisibleSlides(props.defaultVisibleSlide);
        }
    }, [props.defaultVisibleSlide]);
    return (React__default['default'].createElement("div", { className: "lp__carousel " + props.className },
        props.titleH2 ? (React__default['default'].createElement("h2", { style: { textAlign: props.titlePosition || 'left' } }, props.titleH2)) :
            props.title && (React__default['default'].createElement("h4", { style: { textAlign: props.titlePosition || 'left' } }, props.title)),
        React__default['default'].createElement(index_es.CarouselProvider, { totalSlides: props.items.length, visibleSlides: visibleSlides, interval: props.interval || 5000, isPlaying: props.isPlaying, infinite: props.infinite || true, isIntrinsicHeight: true, currentSlide: props.currentSlide, naturalSlideHeight: props.naturalSlideHeight || 200, naturalSlideWidth: props.naturalSlideWidth || 150, step: props.step || 1 },
            React__default['default'].createElement(index_es.Slider, { className: classSliderCenterMode, trayTag: props.trayTag || "ul" }, props.slides(props.items)),
            props.dotGroup &&
                props.items.length > (props.defaultVisibleSlide || 4) && (React__default['default'].createElement(index_es.DotGroup, { className: props.dotGroupClassName, renderDots: function (value) {
                    var carouselStore = value.carouselStore;
                    var currentSlide = carouselStore.getStoreState().currentSlide;
                    return tslib_es6.__spreadArrays(new Array(Math.round(props.items.length - props.defaultVisibleSlide) +
                        1)).map(function (_, i) { return (React__default['default'].createElement("div", { key: i, className: index['default']('carousel__dot carousel__single-dot', currentSlide === i && 'selected'), onClick: function () {
                            return carouselStore.setStoreState({ currentSlide: i });
                        } })); });
                } })),
            props.showArrow && (React__default['default'].createElement(React__default['default'].Fragment, null,
                React__default['default'].createElement(index_es.ButtonBack, tslib_es6.__assign({ className: "button__back" }, (props.changeSlide
                    ? { onClick: function () { return props.changeSlide(props.currentSlide - 1); } }
                    : {})),
                    React__default['default'].createElement("i", { className: "icon ion-ios-arrow-back" })),
                React__default['default'].createElement(index_es.ButtonNext, tslib_es6.__assign({ className: "button__next" }, (props.changeSlide
                    ? { onClick: function () { return props.changeSlide(props.currentSlide + 1); } }
                    : {})),
                    React__default['default'].createElement("i", { className: "icon ion-ios-arrow-forward" })))))));
};
var CarouselSlide = function (props) {
    return (React__default['default'].createElement(index_es.Slide, { index: props.index, className: props.className, tag: props.tag || "li" }, props.children));
};

exports.Carousel = Carousel;
exports.CarouselSlide = CarouselSlide;
//# sourceMappingURL=Carousel.js.map
